export const ROUTES = {
  // Основные маршруты
  Home: {
    path: "/",
    name: "Главная",
  },

  About: {
    path: "/about",
    name: "О бренде AQUASTRONG",
  },

  ProductsRange: {
    path: "/products",
    name: "Продукты",
  },

  ProductsSeries: {
    path: "/products/:categoryId",
    name: "Продукты",
  },

  ProductsDetails: {
    path: "/products/:categoryId/:seriesName",
    name: "Продукты",
  },

  SelectionType: {
    path: "/selection",
    name: "Программа подбора",
  },

  PumpsRange: {
    path: "/selection/series",
    name: "Подбор по серии оборудования",
  },

  PumpsSelection: {
    path: "/selection/series/:seriesId/:pumpId?",
    name: "Подбор по серии оборудования",
  },

  // Dev-версия калькулятора — скрытый маршрут, только для админов
  PumpsRangeDev: {
    path: "/selection/series-dev",
    name: "Подбор по серии оборудования",
  },
  PumpsSelectionDev: {
    path: "/selection/series-dev/:seriesId/:pumpId?",
    name: "Подбор по серии оборудования",
  },

  Documentation: {
    path: "/documents",
    name: "Документация",
  },
  DocumentationCatalogs: {
    path: "/documents/catalogs",
    name: "Каталоги",
  },
  DocumentationCertificates: {
    path: "/documents/certificates",
    name: "Сертификаты",
  },
  DocumentationInstructions: {
    path: "/documents/instructions",
    name: "Инструкции",
  },
  DocumentationDrawings: {
    path: "/documents/drawings",
    name: "Чертежи",
  },
  DocumentationDrawingsSection: {
    path: "/documents/drawings/:sectionId",
    name: "Чертежи",
  },
  DocumentationBimModels: {
    path: "/documents/bim_models",
    name: "BIM-модели",
  },

  PriceList: {
    path: "/price-list",
    name: "Прайс лист",
  },

  Balances: {
    path: "/balances",
    name: "Складские остатки",
  },

  Contacts: {
    path: "/contacts",
    name: "Контакты",
  },

  News: {
    path: "/news",
    name: "Новости",
  },

  References: {
    path: "/references",
    name: "Референции",
  },

  RateHistory: {
    path: "/rate-history",
    name: "История курса",
  },

  PrivacyPolicy: {
    path: "/privacy-policy",
    name: "Политика конфиденциальности",
  },

  // Админская панель
  // Admin: {
  //   path: "/admin",
  //   name: "Панель администрирования",
  // },
};
